import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';
import MUITextField from '@mui/material/TextField';

/**
 * Provide a Text Field visual component using MUI TextField
 */
export default class TextFieldVerySimple extends ReactBrick {
    /**
     * @override
     */
    setupExecution($) {
        return $.observe('Hidden');
    }

    /**
     * @override
     */
    updateParent(parent, element) {
        parent.style.overflow = 'visible'; // Allow overflow
        return super.updateParent(parent, element);
    }

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            // eslint-disable-next-line react/prop-types
            const [hidden] = props.values;

            return !hidden && (
                <MUITextField
                    // Properties
                    value={useProperty($, 'Value', true) || ''}
                    placeholder={useProperty($, 'Placeholder', true)}
                    type={useProperty($, 'Type', true)}
                    variant={'standard'}
                    size={'small'}

                    // Events
                    onChange={(event) => {
                        // Set the Value property before triggering the event
                        $.set('Value', event.target.value);
                        $.trigger('On Change');
                    }}

                    // UI

                    // Affects the input component (wrapper of <input> or <textarea>)
                    // see: https://mui.com/api/text-field/#props
                    InputProps={{
                        sx: {
                            'justifyContent': 'flex-start',
                            'backgroundColor': 'rgba(0,0,0,0)',
                            ':before': {borderBottomColor: 'white'},
                            ':after': {borderBottomColor: 'white'},
                            'color': 'white',
                        },
                        style: {
                            height: '100%',
                        },
                    }}
                    sx={{
                        width: '100%',
                        color: 'white',
                    }}
                />
            );
        };
    }
}

registerBrick('018d365f0e61dbb80b62', TextFieldVerySimple);
